<template>
    <layout-auth>
        <card-auth>
            <div v-show="isSuccess.state !== true">
                <div class="text-right mb-2">
                    <b-btn :to="{ name: 'Login' }"
                        size="sm"
                        class="f-90"
                        variant="icon"
                        >
                        <fa icon="arrow-left" class="mr-1"></fa> {{ $t(`뒤로`) }}
                    </b-btn>
                </div>
                <h6 class="text-left mb-3"> {{ $t(`이메일로 비밀번호 찾기`) }} </h6>

                <b-form class="mb-4"
                    :disabled-field="status"
                    @submit.prevent="sendPassword"
                    >
                    <b-form-group id="reset-group-email" class="mb-4">
                        <b-form-input
                            id="reset-email"
                            v-model.trim="reset_email"
                            type="email"
                            :placeholder="$t(`가입하신 이메일 주소를 입력해주세요`)"
                            class="login-card-input"
                            size="lg"
                            required
                            :disabled="status"
                            />
                    </b-form-group>

                    <b-btn
                        type="submit"
                        class="login-card-submit"
                        variant="dark"
                        size="lg"
                        :disabled="status"
                        block
                        rounded
                        >
                        <template v-if="status">
                            <b-spinner class="reset-spinner" small></b-spinner>
                        </template>
                        <template v-else> {{ $t(`비밀번호 찾기`) }} </template>
                    </b-btn>
                </b-form>
            </div>
            <!-- 임시 비밀번호 전송 완료 -->
            <div v-show="!status && isSuccess.state === true" class="text-center py-5">
                <h6 class="mb-4">
                    {{ $t(`입력하신 이메일로 임시 비밀번호가 전송되었습니다.`) }}
                    <br>
                    {{ $t(`이메일 확인 후 다시 로그인하여 주십시오.`) }}
                </h6>
                <p class="f-90 gray-600 mb-4">{{ $t('메일이 오지 않으면 스팸함을 확인해 주세요.') }}</p>
                <b-btn :to="{ name: 'Login' }"
                    variant="dark-border"
                    >
                    {{ $t(`다시 로그인하기`) }}
                </b-btn>
                <!-- 폼을 다시 보여 같은(또는 고친) 이메일로 다시 보낸다 -->
                <b-btn variant="link" class="ml-2" @click="initiateState">
                    {{ $t('다시 보내기') }}
                </b-btn>
            </div>
            <div v-show="!status && isSuccess.state === false"
                class="text-center fw-500 f-95 text-danger"
                >
                <fa icon="exclamation-circle"></fa> {{ $t(isSuccess.message) }}
            </div>
        </card-auth>
    </layout-auth>
</template>

<script>
import layoutAuth from '@/components/common/layout-auth.vue';
import cardAuth from '@shared_components/common/card-auth.vue';

export default {
    name: 'find-password',
    components: {
        layoutAuth,
        cardAuth
    },
    data: () => ({
        reset_email: null,
        status: false,
        isSuccess: {
            state: null,
            message: null
        }
    }),
    computed: {},
    watch: {},
    created () {
        this.initiateState();
    },
    beforeDestroy () {
        this.initiateState();
    },
    methods: {
        initiateState () {
            this.status = false;
            this.isSuccess = {
                state: null,
                message: null
            };
        },
        async sendPassword () {
            try {
                this.status = true;
                
                //  입력 받은 이메일로 User 정보를 찾음
                await this.$axios.get('/find_user_by_email', {
                    params: {
                        e_mail: this.reset_email,
                        mode: 'qesg_assessment',
                        lang: this.$i18n.locale
                    }
                });

                this.isSuccess.state = true;
            } catch (error) {
                if (error.response) {
                    this.isSuccess = {
                        state: false,
                        message: error.response.status === 404
                            ? '등록되지 않은 이메일입니다.'
                            : '알 수 없는 에러가 발생했습니다. 지원팀에 문의해주세요.'
                    };
                } else {
                    this.isSuccess = {
                        state: false,
                        message: '알 수 없는 에러가 발생했습니다. 지원팀에 문의해주세요.'
                    };
                }
            } finally {
                this.status = false;
            }
        }
    }
};
</script>

<style>

</style>
